import langSample from "./lang-sample";

export default langSample;